export const filter = {
    id: "",
    name: "",
    corps_id: "",
    search: "",
    created_at: "",
    updated_at: "",
};
